import * as PropTypes from 'prop-types';
import * as React from 'react';
import CurationActions from '../actions/curation_actions';

class CuratedSetToggle extends React.Component {
  constructor(props) {
    super(props);
    this.toggleCuration = this.toggleCuration.bind(this);
  }

  get id() {
    return this.props.set.curated_set_id;
  }

  get fieldId() {
    return `curated_set_${this.id}`;
  }

  toggleCuration(evt) {
    if (evt.target.checked) {
      CurationActions.curate(this.id);
      return;
    }

    CurationActions.decurate(this.id);
  }

  renderSaleTag() {
    if (this.props.set.has_sale) {
      return <span className="fa fa-tag ml-half"></span>;
    }

    return null;
  }

  render() {
    if (!this.fieldId) { return null; }

    return (
      <div className="admin-curation-dialog__item">
        <input
          type="checkbox"
          name={this.fieldId}
          id={this.fieldId}
          checked={this.props.set.curated}
          onChange={this.toggleCuration}
        />
        <label htmlFor={this.fieldId}>
          {this.props.set.curated_set_name}
          {this.renderSaleTag()}
        </label>
      </div>
    );
  }
}

CuratedSetToggle.defaultProps = {
  set: {
    curated: false,
  },
};

CuratedSetToggle.propTypes = {
  set: PropTypes.shape({
    curated_set_id: PropTypes.number.isRequired,
    has_sale: PropTypes.bool,
    curated: PropTypes.bool,
    curated_set_name: PropTypes.string,
  }),
};

export default CuratedSetToggle;



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/curation/curated_set_toggle.jsx